/**
 * @generated SignedSource<<be9773d684c4f2bc0c330f8200b499ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoCategoryAssignedToEmployeeList_TodoCategory$data = {
  readonly id: string;
  readonly title: string;
  readonly todos: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdAtDate: {
          readonly isoString: string;
        };
        readonly id: string;
        readonly ordinal: string;
        readonly " $fragmentSpreads": FragmentRefs<"TodoListItem_todo">;
      };
    }>;
  };
  readonly " $fragmentType": "TodoCategoryAssignedToEmployeeList_TodoCategory";
};
export type TodoCategoryAssignedToEmployeeList_TodoCategory$key = {
  readonly " $data"?: TodoCategoryAssignedToEmployeeList_TodoCategory$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCategoryAssignedToEmployeeList_TodoCategory">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "todos"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "assignedToEmployeeId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "assignedToMe"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "createdByEmployeeId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "createdByMe"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./TodoCategoryAssignedToEmployeeListPaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "TodoCategoryAssignedToEmployeeList_TodoCategory",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": "todos",
      "args": [
        {
          "kind": "Variable",
          "name": "assignedToEmployeeId",
          "variableName": "assignedToEmployeeId"
        },
        {
          "kind": "Variable",
          "name": "assignedToMe",
          "variableName": "assignedToMe"
        },
        {
          "kind": "Variable",
          "name": "createdByEmployeeId",
          "variableName": "createdByEmployeeId"
        },
        {
          "kind": "Variable",
          "name": "createdByMe",
          "variableName": "createdByMe"
        },
        {
          "kind": "Literal",
          "name": "includeSubTodos",
          "value": true
        }
      ],
      "concreteType": "TodoConnection",
      "kind": "LinkedField",
      "name": "__TodoCategoryAssignedToEmployeeList_todos_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Todo",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "createdAtDate",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isoString",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ordinal",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TodoListItem_todo"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoCategory",
  "abstractKey": null
};
})();

(node as any).hash = "87ac9d09c368091fef7bb8b50ea2c56e";

export default node;
